// Route guard for /admin/*: renders the nested routes only when the profile's
// effective role is admin; everyone else is bounced to the account home.
// Cosmetic only — the server enforces authz on every /admin endpoint (403).

import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loading } from "@/components/States";

export function RequireAdmin() {
  const { user, userReady } = useAuth();

  // Sits inside RequireAuth, so status is authenticated; wait for /me.
  if (!userReady) {
    return <Loading label="Memeriksa akses…" />;
  }

  if (!user || user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
